import * as Yup from "yup";

const GiftCreationSchema = Yup.object({
  name: Yup.string().required("name is required"),
  code: Yup.string().required("Code is required"),
});
export default GiftCreationSchema;
